import React from 'react'

import { usePlaces } from './_load/PlacesLoader'
import { useSavePlaces } from './_requests/savePlaces'
import { formatFieldValues, useFieldsForBulkForm } from '../../../utils/helpers/fields'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useLevels } from '../editV2/sections/placeLevels/_load/LevelsLoader'
import { formatPlaceForForm } from '../_data/formatPlaceForForm'
import BulkForm from '../../../packages/kiti/components/form/form/BulkForm'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import PlaceLevelSelect from '../../../containers/placeLevels/select/PlaceLevelSelect'

const EditPlacesForm = () => {
  const { type } = useModalData() || {}
  const [fields, { loading: loadingFields }] = useFieldsForBulkForm(type)
  const [onSubmit, { loading, error }] = useSavePlaces()
  const places = usePlaces()
  const levels = useLevels()

  if (loadingFields) return <Loading />

  const isEditing = !!places?.length
  const initialItemValue = { fieldValues: formatFieldValues([], type), type }

  const initialState = isEditing
    ? places.map(item => {
        return {
          ...formatPlaceForForm(item),
          fieldValues: formatFieldValues(item.fieldValues, type),
          type
        }
      })
    : [initialItemValue, initialItemValue]

  const formatFieldName = levelId => {
    if (levelId === null || levelId === undefined) {
      return false
    }
    return `placeLevel${levelId}`
  }

  const placeLevels = levels.map((level, index) => {
    const isName = index === levels.length - 1
    const Input = !isName && PlaceLevelSelect
    const field = isName ? 'name' : formatFieldName(level.id)
    const parentLevel = levels[index - 1]
    const parentIds = value => {
      const parentIds = value[formatFieldName(parentLevel?.id)]?.id
      return { parentIds }
    }
    const disabled = value => {
      const parentPlaceLevelId = value[formatFieldName(parentLevel?.id)]?.id
      return index > 0 && !isName && !parentPlaceLevelId
    }

    return {
      ...level,
      Input,
      label: level.name,
      name: field,
      levelIds: level.id,
      dynamicProps: parentIds,
      parentLevel,
      types: type,
      width: 15,
      disabled
    }
  })

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <Scroll height="69vh" scroll scrollX direction="row">
        <Separator weight={8} flex={1}>
          <BulkForm isEditing={isEditing} initialItemState={initialItemValue} fields={[...placeLevels, ...fields]} />
        </Separator>
      </Scroll>
      <Line />
      <Separator paddingH={2}>
        <SubmitBar loading={loading} error={error} mappedError />
      </Separator>
    </Form>
  )
}

export default EditPlacesForm
